import { client } from 'shared';

export function providerOnStaff(providerUserId: number) {
    return client(`api/staff/is-on-staff/${providerUserId}`);
}

export function toggleProviderStaffStatus(providerUserId: number) {
    return client(`api/staff/toggle-staff/`, { body: { provider_user_id: providerUserId } });
}
